import api from '~services/axios';

export default {
  // 客户公海列表
  queryList: params => api.get('/api/crmCustomerHighsea/queryList', { params }),
  // 公海规则
  queryRuleList: params => api.get('/api/crmHighseaRule/queryList', { params }),
  // 客户公海规则保存接口
  saveRule: params => api.post('/api/crmHighseaRule/saveRule', params),
  // 申请
  applyCustomer: params =>
    api.post('/api/crmCustomerHighsea/applyCustomer', params),
  // 分配
  allocationCustomer: params =>
    api.post('/api/crmCustomerHighsea/allocationCustomer', params),
  // 获取业务员
  queryTeamUser: params =>
    api.get('/api/crmCustomerHighsea/queryTeamUser', { params }),
};
